// extracted by mini-css-extract-plugin
export var standaloneTable = "_1d-0";
export var standaloneTableWithBodyFill = "_1d-1";
export var withExtraHeader = "_1d-2";